/** Contenedor raíz de una vista de Configuration (padding en Sidebar). */
export const configurationPageClass = 'flex min-h-0 w-full flex-1 flex-col overflow-hidden';

/** Separación entre cabecera (título) y contenido principal. */
export const configurationPageContentClass = 'mt-8 min-h-0 flex-1';
